export const curriculum = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    listLoading: false,
    detail: {},
    detailLoading: false,
    deleteLoading: false,
  },
  getters: {
    list: (state) => {
      return state.list
    },
    detail: (state) => {
      return state.detail
    },
    isListLoading: (state) => {
      return state.listLoading
    },
    isDetailLoading: (state) => {
      return state.detailLoading
    },
    isDeleteLoading: (state) => {
      return state.deleteLoading
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setDetail(state, data) {
      state.detail = data
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
    setDetailLoading(state, data) {
      state.detailLoading = data
    },
    setDeleteLoading(state, data) {
      state.deleteLoading = data
    },
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/curriculums`, {
          params: filters,
          paramsSerializer: (params) => {
            return qs.stringify(params, {
              arrayFormat: 'indices',
              allowDots: true,
              skipNulls: true,
            })
          },
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'curriculum/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
    async getDetail({ commit }, id) {
      commit('setDetailLoading', true)
      const response = await axios.get(`/api/curriculums/${id}`)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async create({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.post('/api/curriculums', data)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async update({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.put(`/api/curriculums/${data.id}`, data)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async delete({ commit }, id) {
      commit('setDeleteLoading', true)
      await axios.delete(`/api/curriculums/${id}`)
      commit('setDeleteLoading', false)
    },
  },
}
